import React, { useCallback } from 'react';

import {
  Col,
  Row,
} from 'nexcomponent-ui';
import { useSelector } from 'react-redux';

import { searchFormData } from '../../../../../Utils/Form';
import style from '../FieldSearch/Field.module.css';
import FieldSearch from '../FieldSearch/FieldSearch';

function FieldProductBrandPrincipalSearchForm(props) {
  const {t} = props;
  const searchData = useSelector(state => state.utils.searchData);

  const formData = useCallback( e => {
    searchFormData(e, searchData, props.dispatch);
  },[props.dispatch, searchData]);
  
  return (
    <Row>
      <Col className={style.Col} size="lg" width={6}>
        <FieldSearch
          className={style.InputLeft}
          label={props.t("COMMON:FIELD.PRODUCT_BRAND_ID")}
          type={"number"}
          name="principal_product_brand_id"
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRODUCT_BRAND_ID")})}
          onChange={formData}
        />
        <FieldSearch
          className={style.InputLeft}
          label={t("COMMON:FIELD.PRINCIPAL_CODE")}
          type={"text"}
          name={"principal_code"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_CODE")})}
          onChange={formData}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"text"}
          name={"principal_name"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_NAME")})}
          onChange={formData}
          label={t("COMMON:FIELD.PRINCIPAL_NAME")}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"number"}
          name={"principal_id"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.PRINCIPAL_ID")})}
          onChange={formData}
          label={t("COMMON:FIELD.PRINCIPAL_ID")}
        />
        <FieldSearch
          className={style.InputLeft}
          type={"text"}
          name={"code"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.CODE")})}
          onChange={formData}
          label={t("COMMON:FIELD.CODE")}
        />
      </Col>
      <Col className={style.Col} size="lg" width={6}>
        <FieldSearch
          className={style.InputRight}
          name={"name"}
          placeholder={t("COMMON:PLACEHOLDER", {field: t("COMMON:FIELD.NAME")})}
          onChange={formData}
          message={t("COMMON:ERROR.LETTER", {
            field: t("COMMON:FIELD.CODE"),
            exp: t("COMMON:EXP.COMPANY"),
          })}
          label={t("COMMON:FIELD.NAME")}
        />
      </Col>
    </Row>
  );
}

export default FieldProductBrandPrincipalSearchForm;
